import script from "./TagList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TagList.vue"]])

export default __exports__